import {
  GET_LIST_NOTICE_FROM_TCT,
  GET_LIST_NOTICE_FROM_TCT_FAIL,
  GET_LIST_NOTICE_FROM_TCT_SUCCESS,
  RESET_LIST_NOTICE_FROM_TCT,
  SET_COLUMN_VISIBLE_NOTICE_FROM_TCT,
} from "./actionTypes";
// Đăng ký sử dụng
export const getListNoticeFromTCT = params => ({
  type: GET_LIST_NOTICE_FROM_TCT,
  params,
});

export const getListNoticeFromTCTSuccess = (listData, totalCount) => ({
  type: GET_LIST_NOTICE_FROM_TCT_SUCCESS,
  listData,
  totalCount,
});

export const getListNoticeFromTCTFail = error => ({
  type: GET_LIST_NOTICE_FROM_TCT_FAIL,
  error,
});

export const resetListNoticeFromTCT = error => ({
  type: RESET_LIST_NOTICE_FROM_TCT,
});

// show/hide column
export const setColumnVisibleNoticeFromTCT = (field, value) => ({
  type: SET_COLUMN_VISIBLE_NOTICE_FROM_TCT,
  field,
  value,
});
